import { render, staticRenderFns } from "./DataPopupModal.vue?vue&type=template&id=b957c866&scoped=true"
import script from "./DataPopupModal.vue?vue&type=script&lang=js"
export * from "./DataPopupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b957c866",
  null
  
)

export default component.exports